import { COOKIE } from "~/const/cookie";
import { visitorUuid } from "~/pages/_app";
import { getCookie } from "~/util/get-cookie";
import { isBot } from "~/util/is-bot";

const BOT_ID = "68ad3f99-c85d-42c7-98d0-47795689ea33";

export const useVisitorId = () => {
  if (isBot()) return BOT_ID;

  return getCookie(COOKIE.VISITOR_ID.KEY) || visitorUuid;
};
